exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * To be used with CSS Modules rendered by the webpack.config.\n * Any styles specific to the Evaluation module should live here.\n * Import as neede like so:\n * ...\n * import evaluationStyles from 'evaluationModuleStyles.css';\n * ...\n * render() {\n *   return(\n *     <div styleName=\"evaluation-item\">\n * ...\n */\n\n.modules-evaluation-___evaluationModuleStyles__evaluation-item___1QwP0 {\n\n}\n\n\n.modules-evaluation-___evaluationModuleStyles__new-question___1EKrU {\n  border: 1px solid #ddd;\n  padding: 10px;\n}\n\n.modules-evaluation-___evaluationModuleStyles__new-question___1EKrU .modules-evaluation-___evaluationModuleStyles__-form___1Ri34 {\n  \n}\n\n.modules-evaluation-___evaluationModuleStyles__new-question___1EKrU .modules-evaluation-___evaluationModuleStyles__-prompt___15IfO {\n  text-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"evaluation-item": "modules-evaluation-___evaluationModuleStyles__evaluation-item___1QwP0",
	"new-question": "modules-evaluation-___evaluationModuleStyles__new-question___1EKrU",
	"-form": "modules-evaluation-___evaluationModuleStyles__-form___1Ri34",
	"-prompt": "modules-evaluation-___evaluationModuleStyles__-prompt___15IfO"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./modules/evaluation/evaluationModuleStyles.css
// module id = 1349
// module chunks = 1